import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Home` — home icon.
 * Aria label:    Home
 * Family:        navigation
 * Related:       sidebar, panel-left, panel-right, layout-grid, layout-list, layout-dashboard
 * Canonical use: home glyph in navigation UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Home.
 *
 */
export const Home = forwardRef(function Home(props, ref) {
    return (_jsx(IconBase, { ref: ref, ...props, children: _jsx("path", { d: "M3 11 l9 -7 9 7 v9 a2 2 0 0 1 -2 2 h-4 v-6 h-6 v6 H5 a2 2 0 0 1 -2 -2 z" }) }));
});
//# sourceMappingURL=home.js.map